module.exports = {
    Bem: require('./src/components/bem/bem.react').default,
    BPage: require('./src/components/b-page/b-page.react').default,
    Attach: require('./src/components/attach/attach.react').default,
    BStatcounter: require('./src/components/b-statcounter/b-statcounter.react').default,
    Button: require('./src/components/button/button.react').default,
    CheckBox: require('./src/components/checkbox/checkbox.react').default,
    Control: require('./src/components/control/control.react').default,
    Copyright: require('./src/components/copyright/copyright.react').default,
    Dropdown: require('./src/components/dropdown/dropdown.react').default,
    Font: require('./src/components/font/font.react').default,
    Footer: require('./src/components/footer/footer.react').default,
    Header: require('./src/components/header/header.react').default,
    Icon: require('./src/components/icon/icon.react').default,
    IServices: require('./src/components/i-services/i-services.react').default,
    Image: require('./src/components/image/image.react').default,
    Keycodes: require('./src/components/keycodes/keycodes.react').default,
    LangSwitcher: require('./src/components/lang-switcher/lang-switcher.react.js').default,
    Link: require('./src/components/link/link.react').default,
    Logo: require('./src/components/logo/logo.react').default,
    Menu: require('./src/components/menu/menu.react').default,
    MFooter: require('./src/components/m-footer/m-footer.react').default,
    Modal: require('./src/components/modal/modal.react').default,
    Pointerfocus: require('./src/components/pointerfocus/pointerfocus.react').default,
    Popup: require('./src/components/popup/popup.react').default,
    Progress: require('./src/components/progress/progress.react').default,
    RadioButton: require('./src/components/radio-button/radio-button.react').default,
    RadioBox: require('./src/components/radiobox/radiobox.react').default,
    Search2: require('./src/components/search2/search2.react').default,
    Select: require('./src/components/select/select.react').default,
    ServiceIcon: require('./src/components/service-icon/service-icon.react').default,
    Spin: require('./src/components/spin/spin.react').default,
    TableauNode: require('./src/components/tableau-node/tableau-node.react').default,
    TextArea: require('./src/components/textarea/textarea.react').default,
    TextInput: require('./src/components/textinput/textinput.react').default,
    Ticker: require('./src/components/ticker/ticker.react').default,
    Tooltip: require('./src/components/tooltip/tooltip.react').default,
    Tumbler: require('./src/components/tumbler/tumbler.react').default,
    UserAccount: require('./src/components/user-account/user-account.react').default,
    UserPic: require('./src/components/user-pic/user-pic.react').default,
    User: require('./src/components/user/user.react').default
};
